/**
 * Componente presentacional para mostrar galería de imágenes del pedido/albarán
 * Material-UI, responsive
 */
import React from "react";
import {
    Box,
    Typography,
    CircularProgress,
    Card,
    CardContent,
    Stack
} from "@mui/material";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import ImagenAmpliable from "../../../../components/comun/ImagenAmpliable";
import SelectorArchivos from "../../../../components/comun/selectorArchivos";
import HostService from "../../../../services/host.service";
import { RUTAS } from "../../../../config/constants";

const ImagenesOrden = ({
    imagenes = [],
    completo = false,
    // Permite seguir subiendo con el pedido completo (lo activa la página, ver Sales)
    permitirImagenesCompleto = false,
    onFilesChange,
    // Loading
    loading = false
}) => {
    if (loading) {
        return (
            <Card
                sx={{
                    mt: 3,
                    backgroundColor: "#fff",
                    borderRadius: 2,
                    border: "1px solid #e9ecef",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                    <CircularProgress size={30} />
                </Box>
            </Card>
        );
    }

    const puedeSubir = !completo || permitirImagenesCompleto;

    // No mostrar nada si no hay imágenes ni se puede subir ninguna
    if ((!imagenes || imagenes.length === 0) && !puedeSubir) {
        return null;
    }

    const tieneImagenes = imagenes && imagenes.length > 0;

    return (
        <Card
            sx={{
                mt: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                border: "1px solid #e9ecef",
                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    p: 2.5,
                    backgroundColor: "#f8f9fa",
                    borderBottom: "2px solid #e9ecef",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 36,
                        height: 36,
                        borderRadius: 1.5,
                        backgroundColor: "#fff",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.06)"
                    }}
                >
                    <PhotoLibraryIcon sx={{ fontSize: 20, color: "#cc071e" }} />
                </Box>
                <Box sx={{ flex: 1 }}>
                    <Typography
                        sx={{
                            fontSize: 11,
                            fontWeight: 600,
                            color: "#6c757d",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            mb: 0.25
                        }}
                    >
                        Imágenes
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: 16,
                            fontWeight: 700,
                            color: "#212529",
                            lineHeight: 1.2
                        }}
                    >
                        {tieneImagenes
                            ? `${imagenes.length} ${imagenes.length === 1 ? 'imagen' : 'imágenes'}`
                            : 'Agregar imágenes'}
                    </Typography>
                </Box>
            </Box>

            {/* Contenido */}
            <CardContent sx={{ p: 3 }}>
                {tieneImagenes && (
                    <Box sx={{ mb: puedeSubir ? 2 : 0 }}>
                        <Stack
                            direction="row"
                            flexWrap="wrap"
                            gap={1}
                        >
                            {imagenes.map((img, i) => (
                                <ImagenAmpliable
                                    key={img.ruta || i}
                                    src={`${HostService.getHost() + RUTAS.IMAGENES}/${img.ruta}`}
                                    alt={`imagen-${i}`}
                                />
                            ))}
                        </Stack>
                    </Box>
                )}

                {puedeSubir && (
                    <Box>
                        {tieneImagenes && (
                            <Typography variant="body2" fontWeight={600} sx={{ mb: 1 }}>
                                Agregar más imágenes:
                            </Typography>
                        )}
                        <SelectorArchivos
                            acumular={false}
                            onFilesChange={onFilesChange}
                        />
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default ImagenesOrden;
